import { lit } from '../../utils/literal.js';

/**
 * 外部轮廓样式类型
 *
 * @internal
 */
var OutlineType;
(function (OutlineType) {
    /** 默认样式 */
    OutlineType["DEFAULT"] = "normal-outline";
    /** input 样式，左右margin 为2px，背景为白底，有边框 */
    OutlineType["INPUT"] = "input-outline";
})(OutlineType || (OutlineType = {}));
/**
 * 工具位置类型
 *
 * @public
 */
const ToolbarAlignment = {
    LEFT: lit('left'),
    CENTER: lit('center'),
};

export { OutlineType, ToolbarAlignment };
//# sourceMappingURL=toolbar-config.interface.js.map
